import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/tiers/partners/bulk-clear
//
// Resets a batch of partners to the empty tier state (drops assignments +
// nulls the legacy tier mirror). Invalidates the partners list + the default
// program's assignment caches so the table and any open tier surfaces refresh.
export function useBulkClearTiers() {
  const queryClient = useQueryClient();
  return useMutation<{ cleared: number }, ApiClientError, string[]>({
    mutationFn: (partnerIds) =>
      apiFetch<{ cleared: number }>("/admin/tiers/partners/bulk-clear", {
        method: "POST",
        body: JSON.stringify({ partner_ids: partnerIds }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.tiers.programs.list() });
    },
  });
}
